export const filingTimeFormat = 'h:mm a';
export const FILING_ALIASES = {
  crdt: 'credit card',
  cmbs: 'commercial mortgages',
  eqip: 'equipment',
  slab: 'student',
};

export const FILE_TYPE_ABBEVIATION_MAP = {
  'EX-102': 'Data Tape',
  'EX-103': 'Related Document',
};

export const XML_FILE_TYPE = {
  ASSET_DATA_FILE: 'EX-102',
  ASSET_RELATED: 'EX-103',
};

export const LOAN_LEVEL_PAGE_TITLE = 'US ABS Loan-Level Data (filed on EDGAR)';
export const ISSUE_PIPELINE_PAGE_TITLE = 'US ABS New Issue Pipeline';

export const loanLevelNoAccessFeatures = [
  'Export XML to CSV converted datatapes',
  'Simplify setting up and cracking data tapes with StratMaker',
  'Drill down into underlying asset composition across transactions and issuers',
];

export const loanLevelNoAccessTitle = 'Loan-Level Data';

export const loanLevelNoAccessDescription = 'Finsight’s US ABS Loan-Level Data tracks SEC ABS-EE asset-level' +
                                            ' disclosures and converts them into clean, digestible CSV renderings.' +
                                            ' \n \nUse StratMaker to instantly crunch millions of data points for' +
                                            ' clean and consistent stratification tables of underlying asset & ' +
                                            'performance data across thousands of auto loan and lease transactions.';

export const loanLeveNoAccessImageCaption = 'Search and filter through 25,000+ ABS-EE EDGAR filings in clean CSV' +
                                            ' formats.';
